import { ReactNode } from 'react';
import styled from 'styled-components';

import theme from '@styles/theme';

import { RegularFont } from '@components/styled/StyledComponents';

type MainProps = {
    children?: ReactNode;
    title?: string;
    subTitle?: string;
    fontSize?: number;
};

const Main = ({ children, title, subTitle, fontSize = 24 }: MainProps) => {
    return (
        <Wrapper>
            <PageInfo>
                <Title $fontSize={fontSize}>{title}</Title>
                {subTitle && <SubTitle>{subTitle}</SubTitle>}
            </PageInfo>
            {children}
        </Wrapper>
    );
};

export default Main;

const Wrapper = styled.section`
    width: 1280px;
    min-height: calc(100vh - 80px);
    margin: 0 auto;
    padding-bottom: 100px;
`;

const PageInfo = styled.div`
    padding: 32px 0;
    border-bottom: 1px solid ${theme.colors.ultraLightGrayBorder};
`;

const Title = styled.h2<{ $fontSize?: number }>`
    font-size: ${({ $fontSize }) => $fontSize}px;
    font-family: PretendardSemiBold, sans-serif;
`;

const SubTitle = styled(RegularFont)`
    margin-top: 12px;
    font-size: 14px;
    color: ${theme.colors.deepGrayFontColor};
`;
